import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useProjectManagementPageStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    paddingLeft: designTokens.spacing[6],
    paddingRight: designTokens.spacing[6],
    "@media (max-width: 640px)": {
      paddingLeft: designTokens.spacing[4],
      paddingRight: designTokens.spacing[4],
    },
  },

  headerRow: {
    display: "flex",
    paddingTop: designTokens.spacing[4],
    paddingRight: designTokens.spacing[4],
    alignItems: "center",
    gap: designTokens.spacing[2],
    "@media (max-width: 480px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  title: {
    lineHeight: 1.1,
  },

  sectionScrollArea: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    padding: designTokens.spacing[4],
    display: "flex",
    flexDirection: "column",
    backgroundColor: designTokens.neutral.white,
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: designTokens.shadow.sm,
  },

  tabList: {
    "--colorCompoundBrandForeground1": designTokens.neutral[900],
    "--colorCompoundBrandForeground1Hover": designTokens.neutral[900],
    "--colorCompoundBrandForeground1Pressed": designTokens.neutral[900],
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
  },

  tab: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.normal,
    color: designTokens.neutral[500],
    "&[aria-selected='true']": {
      fontWeight: designTokens.fontWeight.normal,
      color: designTokens.neutral[900],
    },
    "& .fui-Tab__content": {
      color: "inherit",
    },
    "&::after": {
      width: "100%",
      left: 0,
      right: 0,
    },
  },

  tabRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[2],
  },

  tabContentArea: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    maxWidth: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    paddingTop: designTokens.spacing[6],
  },

  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    flex: 1,
  },

  notFoundText: {
    textAlign: "center" as const,
  },
});
